import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IShipmentDetails } from '../../../Fleet/new-driver/model/IDriverFormModel';
import { appService } from '../../../../app/_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { Helpers } from '../../../../app/helpers';
import { ITableModel } from '../table/model/tableModel';

const LNG_KEY = "SELECTED_LANGUAGE";

@Component({
  selector: 'app-shipments',
  templateUrl: './shipments.component.html',
  styleUrls: ['./shipments.component.scss']
})
export class ShipmentsComponent implements OnInit, OnChanges {

  @Input() data: any;
  @Output() modifiedValueOutput = new EventEmitter<any>();
  @Output() dataViewCatch = new EventEmitter<any>();
  @Output() onSave = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();
  @Output() onPageChangeEvent = new EventEmitter<number>();
  @Input() totalShipmentCount: number = 0;
  // @Input() tableDetails: any
  tableDetails: ITableModel;
  @Input() pageTitle: any;
  @Input() selectedRowId: any;
  driverId: any;
  ShipmentDetail: IShipmentDetails = {};
  noOfPages: number = 15;
  CompanyId: any
  selectedContact: IShipmentDetails = {};
  modalRef: any;
  visible: boolean = false;
  userId: any;
  totalCount: number = 0
  fromDate: any;
  toDate: any;
  filterFromdate: Date; // Keep as Date type
  filterTodate: Date;
  isMobileView: boolean;

  shipmentDetails: any = {
    cardName: "Shipment",
    id: "shipmentDetails",
    listOfRow: [
      [{
        label: 'Trip No', dataField: 'Tripnumber', dataField1: 'Date',
      },
      {
        label: 'Customer', dataField: 'Customer'
      }],
      [{
        label: 'From Location', dataField: 'FromLocation'
      },
      { label: 'To Location', dataField: 'ToLocation'}],
    ],
    footer: {
      isActiveDatafield: 'CurrentStatus',
      color: '#3367FB',
    }
  };

  constructor(
    private modalService: NgbModal,
    private translate: TranslateService,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private mobileDetectionService: MobileDetectionService,
  ) {
   }

  ngOnInit(): void {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("UserId"))
    );
    const storedPerPage = localStorage.getItem('perPage');
    if (storedPerPage) {
        this.noOfPages = parseInt(storedPerPage, 10);
    }
    this.initailizeForm();
    this.setInitialDates();
    this.GetShipmentData(0, this.noOfPages, this.selectedRowId)
    console.log('tableDetails',this.tableDetails, this.data,this.selectedRowId)
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
  }

  initailizeForm() {
    this.tableDetails = {
      data: [],
      emptyDataMSg: 'No Data Found',
      columnDetails: [
        { columnName: 'Trip No', dataFieldName: 'Tripnumber' },
        { columnName: 'Assign Date', dataFieldName: 'Date' },
        { columnName: 'Customer', dataFieldName: 'Customer', },
        { columnName: 'From Location', dataFieldName: 'FromLocation' },
        { columnName: 'To Location', dataFieldName: 'ToLocation' },
        { columnName: 'Status', dataFieldName: 'CurrentStatus' },
      ],
      isColumnNameShow: true,
      actionList: [
        // { label: 'Edit', icon: 'pi pi-fw pi-eye' },
        // { label: 'Delete', icon: 'pi pi-fw pi-trash' },
      ]
    };
    this.fromDate = {
      lable: 'From Date',
      dataField: 'fromDate',
      formControlName: 'fromDate',
      placeholder: 'Select From Date'
    };
    this.toDate = {
      lable: 'To Date',
      dataField: 'toDate',
      formControlName: 'toDate',
      placeholder: 'Select To Date'
    };
  }

  ngOnChanges(): void {
    if (this.data && this.tableDetails) {
    this.tableDetails.data = this.data.length ? this.data : []; // Clear data if input is empty
    }
    this.GetShipmentData(0, this.noOfPages, this.selectedRowId);
  }

  ngOnDestroy(){
    localStorage.removeItem('perPage');
  }

  open(content, isNew = false) {
    isNew ? this.selectedContact = {} : null
    this.modalRef = this.modalService.open(content);
  }

  getChangedValue(value, data) {
    if(data == 'fromDate'){
      this.filterFromdate = new Date(value)
    }
    if(data == 'toDate'){
      this.filterTodate = new Date(value)
    }
    this.GetShipmentData(0, this.noOfPages, this.selectedRowId)
    console.log('date', this.filterFromdate, this.filterTodate, value, data)
    // this.selectedContact[dataFeild] = value;
    // this.modifiedValueOutput.emit({ value, dataFeild })
    // console.log("getchanged", value, dataFeild);
  }

  GetShipmentData(pageNo: number = 0, perPage: any = this.noOfPages, id) {
    Helpers.setLoading(true);
    localStorage.setItem('perPage', perPage);
    var obj: any = {}
    obj.start = 0
    obj.length = perPage
    obj.CompanyId = this.CompanyId;
    obj.userid = this.userId;
    obj.filterOption = 'All';
    obj.fromDate = this.formatDate(this.filterFromdate);
    obj.toDate = this.formatDate(this.filterTodate);
    obj.SearchValue = ''
    obj.driverId = id
    this._appService.Post("Booking", "GetTrips", obj).subscribe((response) => {
      if (response && response.length > 0) {
        this.totalCount = response.count;
        this.assignTableFields(pageNo, perPage, response);
      } else {
        this.totalCount = 0;
        this.tableDetails.data = []; // Clear table data to avoid showing stale data
      }
      Helpers.setLoading(false);
    },
    (err) => {
      Helpers.setLoading(false);
      // this.toastr.error(this.translate.instant("User.ErrorMessage"),"error");
    });
  }

  assignTableFields(pageNo, perPage, data) {
    this.tableDetails = {
      ...this.tableDetails,
      paginationDetails: {
        totalItems: this.totalCount,
        itemsPerPage: perPage,
        currentPage: pageNo + 1,
      },
      data: data,
    };
  }

  onActionClick({ row, actionName }) {
    if (actionName == 'Delete') {
      this.onDelete.emit(row);
    } else {
      this.visible = true;
      this.selectedContact = { ...row };
      this.dataViewCatch.emit(this.selectedContact);
    }
    console.log(row)
  }

  onPageChange(pageNo: number) {
    const storedPerPage = localStorage.getItem('perPage') || this.noOfPages;
    this.GetShipmentData(pageNo - 1, storedPerPage, this.selectedRowId);
  }

  onPageNumberChange(noOfPages: any) {
    localStorage.setItem('perPage', noOfPages);
    this.GetShipmentData(0, noOfPages, this.selectedRowId);
  }

  onSaveBtnClick() {
    this.modalRef.close();
    this.onSave.emit();
  }

setInitialDates() {
  const currentDate = new Date(); // Current Date
  this.filterTodate = currentDate; // Set `toDate` as today's date

  // Set `fromDate` as the first day of the previous month
  const previousMonthFirstDay = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() - 1,
    1
  );
  this.filterFromdate = previousMonthFirstDay;

  console.log("From Date (Date Object):", this.filterFromdate);
  console.log("To Date (Date Object):", this.filterTodate);
}

// Use this method to convert Date to formatted string only when needed
formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure two-digit month
  const day = String(date.getDate()).padStart(2, '0'); // Ensure two-digit day
  return `${year}-${month}-${day}`;
}


}
